<script setup lang="ts">
import type { UserData } from '@/api/queries/user/types/user';
import PrivacyCard from '@/features/privacy/PrivacyCard.vue';
import { usePrivacy } from '@/features/privacy/usePrivacy';

type Props = {
  context: 'share' | 'settings';
};

defineProps<Props>();
const visibility = defineModel<UserData['profile_visibility']>({ required: true });

const { visibilityOptions } = usePrivacy();
</script>

<template>
  <v-item-group v-model="visibility" mandatory class="flex flex-col sm:flex-row gap-6">
    <template v-for="(option, index) in visibilityOptions" :key="`privacy-${index}`">
      <v-item v-slot="{ isSelected, toggle }" :value="option.value">
        <PrivacyCard
          v-if="option.display"
          :is-selected="isSelected"
          :toggle="toggle"
          context="edit"
          :visibility-option="option"
        />
      </v-item>
    </template>
  </v-item-group>
</template>
